import { zoomIdentity } from 'd3-zoom';
import { ECG_CONSTANTS } from '../utils/constants';
import { IChartContext, ILayerViewModel } from '../models/interfaces';

export class ChartViewModel implements IChartContext {
    // data members

    activeLayer: ILayerViewModel | null = null;
    opacity: number = 1;
    leadHeight = ECG_CONSTANTS.LEAD_HEIGHT;
    transform = zoomIdentity;
    isBusy = false;

    constructor() {
        // This is intentional
    }

    private _layers = new Array<ILayerViewModel>();

    get layers() {
        return this._layers;
    }

    private _leadWidth = 0;

    // constructor

    get leadWidth() {
        return this._leadWidth;
    }

    // public functions

    updateLeadWidth(leadWidth: number) {
        this._leadWidth = leadWidth;
    }
}
